<script setup>
import { computed, getCurrentInstance, reactive } from 'vue';
import Button from "../Button.vue";

const props = defineProps({
    formId: String,
    field: Object,
    modalTitle: String,
    currentData: Object,
    mode: String,
});

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// State
const codeMirrorState = reactive({});

// Computed
const originalData = computed(() => {
    return store.state[props.formId].originalData;
});

const tableName = computed(() => {
    return store.state[props.formId].tableName;
});

// Methods
const onClick = () => {
    const indent = 2;
    const mode = props.mode || 'text/html';

    let originalValue = originalData.value[props.field.name];
    if (typeof originalValue === 'object') {
        originalValue = JSON.stringify(originalValue, undefined, indent);
    }

    let value = props.currentData[props.field.name];
    if (typeof value === 'object') {
        value = JSON.stringify(value, undefined, indent);
    }

    store.dispatch('modals/show', {
        componentName: 'CodeMirrorModal',
        obj: {
            formId: props.formId,
            tableName: tableName.value,
            field: props.field,
            modalTitle: props.modalTitle,
            mode: mode,
            readOnly: props.readOnly,
            originalValue: originalValue,
            currentData: props.currentData,
            value: value,
            state: codeMirrorState,
        }
    });
};

// Initialization (Equivalent to created lifecycle hook)
const init = () => {
    if (props.currentData[props.field.name] === undefined) {
        store.commit(props.formId + '/presetData', {
            name: props.field.name,
            value: ''
        });
    }

    // Refresh logic to prevent stale data
    if (props.currentData.id) {
        store.dispatch('itemData/get', {
            tableName: tableName.value,
            id: props.currentData.id,
            refresh: true,
        }).then((obj) => {
            props.currentData[props.field.name] = obj[props.field.name];
        });
    }
};

init();
</script>

<template>
    <Button @click.native="onClick" class="border">
        {{ field.buttonText || 'Edit' }}
    </Button>
</template>